import { ModelState } from "../../interfaces/modelState";

export const hasValidationMessage = (modelState: ModelState | null | undefined, propertyName?: string) => {
  const property =
    modelState && propertyName
      ? Object.keys(modelState).find((key) => key.toLowerCase() === propertyName.toLowerCase())
      : undefined;

  if (!modelState || !property) {
    return false;
  }

  const errorMessage = modelState[property];

  if (!errorMessage) {
    return false;
  }

  return (Array.isArray(errorMessage) && Boolean(errorMessage.length > 0)) || !Array.isArray(errorMessage);
};
